import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchDespatcho } from "../features/despatcho/despatchoSlice";

import DespatchoForm from "./DespatchoForm";
import DespatchoTable from "./DespatchoTable";

function Despatcho() {

    const dispatch = useDispatch();

    const { loading, error } = useSelector(
        (state) => state.despatcho
    );

    useEffect(() => {

        dispatch(fetchDespatcho());

    }, [dispatch]);

    if (loading) {

        return (

            <div className="text-center mt-5">

                <div className="spinner-border text-primary"></div>

            </div>

        );

    }

    if (error) {

        return (

            <div className="alert alert-danger">

                {error}

            </div>

        );

    }

    return (

        <div className="container-fluid mt-3">

            <div className="row">

                <div className="col-lg-4">

                    <DespatchoForm />

                </div>

                <div className="col-lg-8">

                    <DespatchoTable />

                </div>

            </div>

        </div>

    );

}

export default Despatcho;